import { Flex } from "@mantine/core";

import { ProductSaleFlow } from "./ProductSaleFlow";

export function ProductSaleFlowPanel() {
    return (
        <Flex pos={"absolute"} inset={0} bg="dark.7">
            <ProductSaleFlow />
        </Flex>
    );
}
